import { render, staticRenderFns } from "./vendor-orders.vue?vue&type=template&id=8f376d64&scoped=true"
import script from "./vendor-orders.vue?vue&type=script&lang=js"
export * from "./vendor-orders.vue?vue&type=script&lang=js"
import style0 from "./vendor-orders.vue?vue&type=style&index=0&id=8f376d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f376d64",
  null
  
)

export default component.exports